export default "__VITE_ASSET__CokAXza5__"